import { ICreateMetaTagDTO } from '@/models/metaTags.model';
import { TMetaTagsFormValues } from '../helpers/types';

class CreateMetaTagsDTO implements ICreateMetaTagDTO {
  locale?: Record<string, { title?: string; description?: string; keywords?: string[] }> | undefined;
  slug: string;
  index: '1' | '0';

  constructor({ slug, locale, index }: TMetaTagsFormValues) {
    this.slug = slug;
    this.index = index ? '1' : '0';
    this.locale = Object.fromEntries(
      Object.entries(locale || {}).map(([loc, { seo_title, seo_description, seo_keywords, seo_text }]) => [
        loc,
        {
          title: seo_title,
          description: seo_description,
          keywords: seo_keywords,
          text: seo_text,
        },
      ]),
    );
  }
}

export default CreateMetaTagsDTO;
